import { modelRequest } from "@stem-sims/great-leaps-react-common"

interface CountriesReturn {
    valid: boolean
    countries: string[]
}
export function get(): Promise<CountriesReturn> {
    return modelRequest.get("/api/countries")
}
